module.exports = __webpack_public_path__ + "img/deleteIcon.15c701d9.svg";